// extracted by mini-css-extract-plugin
export default {"item_header":"style_item_header__xAGmF","item_body":"style_item_body__mt7sa","squareInput_button":"style_squareInput_button__UJizx","hasData":"style_hasData__zaAMq"};